import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Cell,
} from "recharts";
import { formatNumber } from "../../../utils/format";

const ClusteredBarChart = ({ data }) => {
  return (
    <div style={{ width: "98%", height: 400 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ left: 100, right: 20, top: 20, bottom: 20 }}
        >
          {/* Gradient Definitions */}
          <defs>
            {/* Positive Values Gradient */}
            <linearGradient
              id="barGradientPositive"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
            >
              <stop offset="0%" stopColor="#4348E3" />
              <stop offset="100%" stopColor="#B0B3FF" />
            </linearGradient>

            {/* Negative Values Gradient */}
            <linearGradient
              id="barGradientNegative"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
            >
              <stop offset="0%" stopColor="#B0B3FF" />
              <stop offset="100%" stopColor="#4348E3" />
            </linearGradient>
          </defs>

          <CartesianGrid horizontal={false} strokeDasharray="3 3" />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) => {
              const absValue = Math.abs(value);
              if (absValue >= 1000000) {
                return `${value < 0 ? "-" : ""}$${(absValue / 1000000).toFixed(
                  2
                )}M`;
              } else if (absValue >= 1000) {
                return `${value < 0 ? "-" : ""}$${(absValue / 1000).toFixed(
                  2
                )}K`;
              } else {
                return `${value < 0 ? "-" : ""}$${absValue.toFixed(0)}`;
              }
            }}
          />

          <YAxis
            dataKey="name"
            type="category"
            axisLine={false}
            tickLine={false}
            tick={{ width: 200, textAnchor: "end", dy: 0 }}
          />
          <Tooltip
            formatter={(value) => {
              const absValue = Math.abs(value).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
              const formatted = value < 0 ? `-$${absValue}` : `$${absValue}`;
              return [formatted, "Amount"];
            }}
            cursor={false}
          />

          <Bar
            dataKey="value"
            radius={[0, 10, 10, 0]}
            style={{ cursor: "pointer" }}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  entry.value >= 0
                    ? "url(#barGradientPositive)"
                    : "url(#barGradientNegative)"
                }
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ClusteredBarChart;
